import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-panels",
    styleUrls: ["./panels.component.scss"],
    templateUrl: "./panels.component.html",
    standalone: false
})
export class FUIPanelsComponent {
    @Input() public showAlert: boolean;

    constructor() {

    }
}
